import * as React from "react";
function SvgBubblePencil(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        d="M15 7H3a2 2 0 00-2 2v14a2 2 0 002 2h16l6 6v-6h4a2 2 0 002-2V9a2 2 0 00-2-2h-2M7 19h8"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M21.88 1l3.56 1.84-5.98 11.54-3.15 1.75-.4-3.58L21.88 1z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgBubblePencil);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
